<!-- Facebook in-stream reels (fullscreen) -->
<div class="mst">
  <div class="mst-screen fbis-screen">
    <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="fullscreen"></app-meta-creative>

    <div class="fbis-actions">
      <i class="bi bi-hand-thumbs-up"></i>
      <i class="bi bi-chat"></i>
      <i class="bi bi-reply fbis-share"></i>
      <i class="bi bi-three-dots"></i>
    </div>

    <div class="fbis-copy">
      <div class="fbis-identity">
        <img class="fbis-avatar" [src]="avatar" alt="" />
        <div>
          <div class="fbis-name">{{ pageName }}<i class="bi bi-globe-americas fbis-globe"></i></div>
          <div class="fbis-label">Sponsored</div>
        </div>
      </div>
      <div class="fbis-text">{{ primaryText.text }}<span *ngIf="primaryText.truncated">... more</span></div>
      <a class="fbis-cta" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">{{ cta }}</a>
    </div>
  </div>
</div>
